
import { Vue, Component, Watch } from 'vue-property-decorator';
import BubbleCard from '~/components/Cards/BubbleCard.vue';
import PaymentSettings from '@/components/Payments/PaymentSettings.vue';
import SimpleStepper from '~/components/Wizards/SimpleStepWizard.vue';
import ResponsiveContainer from '@/components/Layout/ResponsiveContainer.vue';
import PortalIntro from '@/components/common/Dialogs/PortalIntro.vue';

@Component({
  components: { ResponsiveContainer, BubbleCard, PaymentSettings, SimpleStepper },
})
export default class PaymentSetup extends Vue {
  async mounted() {
    try {
      await this.$store.dispatch('PaymentOptions/getPaymentOptions');
    } catch {
      this.$router.push({ name: 'error' });
    }

    if (this.isFirstLogin) {
      this.$dialog({ component: PortalIntro });
    }
  }

  get hasPaymentMethod(): boolean {
    return this.$store.getters['PaymentOptions/hasVerifiedPaymentMethods'];
  }

  get isFirstLogin(): boolean {
    return this.$store.getters['User/isFirstLogin'];
  }

  @Watch('hasPaymentMethod')
  onPaymentMethodChange(isSetup: boolean) {
    if (isSetup) {
      this.$router.push({ name: 'home' });
    }
  }
}
